module.exports = __webpack_public_path__ + "img/logo3.fe560fa9.png";